export const COMPANY = {
  legalName: "Enigma Enterprises LLC",
  brand: "Shoreline RV",
  shortBrand: "Shoreline RV",
  website: "shorelinerv.com",
  contactEmail: "service@shorelinerv.com",
  // Twilio A2P 10DLC compliant ownership wording
  ownershipStatement:
    'Shoreline RV is a registered "doing business as" (DBA) name owned and operated by Enigma Enterprises LLC.',
  effectiveDate: "June 2026",
};
